import { render, staticRenderFns } from "./AppPhotoGallery.vue?vue&type=template&id=23f504d0&scoped=true&"
import script from "./AppPhotoGallery.vue?vue&type=script&lang=js&"
export * from "./AppPhotoGallery.vue?vue&type=script&lang=js&"
import style0 from "./AppPhotoGallery.vue?vue&type=style&index=0&id=23f504d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f504d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCard,VCarousel,VCarouselItem,VDialog,VImg,VSlideGroup,VSlideItem})
